var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartLegendIconIndex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 6,
    viewBox: "0 0 25 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 3C0.25 2.44772 0.697715 2 1.25 2H23.25C23.8023 2 24.25 2.44772 24.25 3C24.25 3.55228 23.8023 4 23.25 4H1.25C0.697715 4 0.25 3.55228 0.25 3Z",
    fill: "#47FFFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.25,
    cy: 3,
    r: 3,
    fill: "#47FFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartLegendIconIndex);
export default __webpack_public_path__ + "static/media/chart-legend-icon-index.3e0bce9e64a305064dd24c7f2480e0ea.svg";
export { ForwardRef as ReactComponent };